/*
 * Rowdy cart: discount codes, the add-on suggestion and dispatch dates, for the cart drawer and the cart page.
 * Discount codes go through the Cart API (/cart/update.js with `discount`), so savings show straight away and
 * carry through to checkout. Shoppers can add several codes and remove any of them. Codes that don't apply are
 * taken off again with a clear message. After each change the drawer, the cart page and the cart bubble are
 * re-rendered from their sections.
 */
(function () {
  var parse = function (html, sel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(sel);
  };

  // Which sections to ask for, and where they go
  function targets() {
    var list = [];
    if (document.querySelector('cart-drawer')) list.push({ section: 'cart-drawer', into: 'cart-drawer .drawer__inner', from: '.drawer__inner' });
    if (document.getElementById('cart-icon-bubble')) list.push({ section: 'cart-icon-bubble', into: '#cart-icon-bubble', from: '.shopify-section' });
    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) list.push({ section: items.dataset.id, into: '#main-cart-items .js-contents', from: '.js-contents' });
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) list.push({ section: footer.dataset.id, into: '#main-cart-footer .js-contents', from: '.js-contents' });
    return list;
  }

  function render(cart, list) {
    if (!cart || !cart.sections) return;
    list.forEach(function (t) {
      var html = cart.sections[t.section];
      var into = document.querySelector(t.into);
      if (!html || !into) return;
      var fresh = parse(html, t.from);
      if (fresh) into.innerHTML = fresh.innerHTML;
    });
    var empty = cart.item_count === 0;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) inner.classList.toggle('is-empty', empty);
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) { var el = document.getElementById(id); if (el) el.classList.toggle('is-empty', empty); });
    dispatchDates();
    shipRates();
  }

  async function post(url, body, retried) {
    var list = targets();
    body.sections = list.map(function (t) { return t.section; }).join(',');
    body.sections_url = window.location.pathname;
    try {
      var res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      var json = await res.json();
      if (!res.ok || json.status) throw Object.assign(new Error(json.description || 'cart error'), { json: json });
      return { cart: json, list: list };
    } catch (e) {
      if (retried || e.json) throw e;
      await new Promise(function (r) { setTimeout(r, 600); });
      return post(url, body, true);
    }
  }
  var updateUrl = function () { return ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js'; };
  var addUrl = function () { return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js'; };

  // Delivery line under the free threshold: show Shopify's live UK Standard rate (cheapest)
  var rateCache = {};
  function shipRates() {
    var els = document.querySelectorAll('[data-ship-rate]');
    if (!els.length) return;
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var key = cart.total_price + ':' + cart.item_count;
        if (rateCache[key]) return rateCache[key];
        var q = 'shipping_address%5Bcountry%5D=United%20Kingdom&shipping_address%5Bzip%5D=BA1%201AA';
        return fetch('/cart/shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var list = (j.shipping_rates || []).map(function (x) { return parseFloat(x.price); }).filter(function (n) { return !isNaN(n); });
            if (!list.length) return null;
            var min = Math.min.apply(null, list);
            var txt = min === 0 ? 'Free' : '£' + (min % 1 ? min.toFixed(2) : String(min));
            rateCache[key] = txt;
            return txt;
          });
      })
      .then(function (txt) {
        if (!txt) return;
        document.querySelectorAll('[data-ship-rate]').forEach(function (el) { el.textContent = txt; el.classList.toggle('rcs__free', txt === 'Free'); });
        // Total includes the delivery charge, so the number matches checkout
        var pence = txt === 'Free' ? 0 : Math.round(parseFloat(txt.replace('£', '')) * 100);
        document.querySelectorAll('[data-cart-total]').forEach(function (el) {
          var t = parseInt(el.dataset.cartTotal, 10) + pence;
          el.textContent = '£' + (t % 100 ? (t / 100).toFixed(2) : String(t / 100));
        });
        document.querySelectorAll('[data-klarna-total]').forEach(function (el) {
          var k = Math.floor((parseInt(el.dataset.klarnaTotal, 10) + pence) / 3);
          el.textContent = '£' + (k % 100 ? (k / 100).toFixed(2) : String(k / 100));
        });
      })
      .catch(function () {});
  }

  // Dispatch promise: turn "within 3–5 working days" into a real date
  function dispatchDates() {
    document.querySelectorAll('[data-dispatch-by]').forEach(function (el) {
      var n = parseInt(el.dataset.dispatchBy, 10);
      if (!n) return;
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); var day = d.getDay(); if (day !== 0 && day !== 6) n--; }
      el.textContent = 'by ' + d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
    });
  }

  if (!customElements.get('rowdy-discount')) {
    customElements.define(
      'rowdy-discount',
      class RowdyDiscount extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.form = this.querySelector('form');
          this.input = this.querySelector('input');
          this.msg = this.querySelector('[data-discount-msg]');
          this.button = this.querySelector('button[type="submit"]');
          if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.apply(); });
          this.querySelectorAll('[data-discount-remove]').forEach(function (b) {
            b.addEventListener('click', function () { self.remove(b.dataset.discountRemove); });
          });
          this.sync();
          var toggle = this.querySelector('[data-discount-toggle]');
          if (toggle) toggle.addEventListener('click', function () {
            var open = self.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (open && self.input) setTimeout(function () { self.input.focus(); }, 50);
          });
        }

        // The Cart API is the source of truth for codes (Liquid doesn't list codes that don't apply yet)
        async sync() {
          try {
            var cart = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
            this.drawChips(cart.discount_codes || []);
          } catch (e) {}
        }

        drawChips(codes) {
          var self = this;
          this.dataset.codes = JSON.stringify(codes.map(function (c) { return c.code; }));
          var ul = this.querySelector('.rowdy-discount__codes');
          if (!codes.length) { if (ul) ul.remove(); this.classList.remove('has-codes'); this.setToggle('Add a discount code'); return; }
          if (!ul) { ul = document.createElement('ul'); ul.className = 'rowdy-discount__codes list-unstyled'; ul.setAttribute('role', 'list'); ul.setAttribute('aria-label', 'Discount codes on your bag'); this.prepend(ul); }
          var icon = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2.5 2.5l7 7m0-7l-7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
          var tag = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M1.5 8.6V2.2c0-.4.3-.7.7-.7h6.4l5.9 5.9a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.4 0z" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="5" cy="5" r="1.1" fill="currentColor"/></svg>';
          ul.innerHTML = codes.map(function (c) {
            var code = String(c.code).replace(/[&<>"']/g, function (m) { return '&#' + m.charCodeAt(0) + ';'; });
            return '<li class="rowdy-discount__code' + (c.applicable ? '' : ' is-inactive') + '"' + (c.applicable ? '' : ' title="Not valid for what\'s in your bag yet"') + '>' + tag +
              '<span>' + code.toUpperCase() + (c.applicable ? '' : ' <em>not applied</em>') + '</span>' +
              '<button type="button" class="rowdy-discount__remove" data-discount-remove="' + code + '" aria-label="Remove code ' + code + '">' + icon + '</button></li>';
          }).join('');
          ul.querySelectorAll('[data-discount-remove]').forEach(function (b) { b.addEventListener('click', function () { self.remove(b.dataset.discountRemove); }); });
          this.classList.add('has-codes');
          
        }

        setToggle(text) { var t = this.querySelector('[data-discount-toggle] span'); if (t) t.textContent = text; }

        current() { try { return JSON.parse(this.dataset.codes || '[]').filter(Boolean); } catch (e) { return []; } }

        // After a re-render this element is replaced; talk to the fresh one in the same place
        fresh() { return document.querySelector('rowdy-discount[data-context="' + this.dataset.context + '"]') || this; }

        say(text, isError, keepOpenWith) {
          var el = this.fresh();
          if (keepOpenWith !== undefined) {
            el.classList.add('is-open');
            var inp = el.querySelector('input'); if (inp) { inp.value = keepOpenWith; inp.focus(); }
          }
          var m = el.querySelector('[data-discount-msg]');
          if (!m) return;
          m.textContent = text || '';
          m.classList.toggle('is-error', !!isError);
        }

        busy(on) { this.classList.toggle('is-busy', on); if (this.button) this.button.disabled = on; }

        async apply() {
          var code = (this.input.value || '').trim();
          if (!code) { this.say(this.dataset.msgEmpty, true); this.input.focus(); return; }
          var codes = this.current();
          if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { this.say(this.dataset.msgAlready, true); return; }
          this.busy(true);
          this.say('');
          var msgs = this.dataset;
          try {
            var r = await post(updateUrl(), { discount: codes.concat(code).join(',') });
            var hit = (r.cart.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
            if (!hit || !hit.applicable) {
              // Take it back off so it doesn't sit in the bag doing nothing
              r = await post(updateUrl(), { discount: codes.join(',') });
              render(r.cart, r.list);
              this.say((msgs.msgInvalid || '').replace('[code]', code.toUpperCase()), true, code);
              return;
            }
            render(r.cart, r.list);
            this.say((msgs.msgApplied || '').replace('[code]', hit.code.toUpperCase()), false);
          } catch (e) {
            this.say(msgs.msgError, true);
          } finally {
            this.busy(false);
          }
        }

        async remove(code) {
          this.busy(true);
          var msgs = this.dataset;
          try {
            var keep = this.current().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
            var r = await post(updateUrl(), { discount: keep.join(',') });
            render(r.cart, r.list);
            this.say((msgs.msgRemoved || '').replace('[code]', code.toUpperCase()), false);
          } catch (e) {
            this.say(msgs.msgError, true);
          } finally {
            this.busy(false);
          }
        }
      }
    );
  }

  // "Goes well with": one small add-on, added without leaving the cart
  if (!customElements.get('rowdy-cart-addon')) {
    customElements.define(
      'rowdy-cart-addon',
      class RowdyCartAddon extends HTMLElement {
        connectedCallback() {
          var self = this;
          var form = this.querySelector('form');
          if (form) form.addEventListener('submit', async function (e) {
            e.preventDefault();
            var id = (form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]')).value;
            var btn = form.querySelector('button');
            btn.disabled = true; self.classList.add('is-busy');
            try {
              var line = { id: Number(id), quantity: 1 };
              if (form.dataset.pairedWith) line.properties = { _paired_with: form.dataset.pairedWith };
              var r = await post(addUrl(), { items: [line] });
              var code = form.dataset.pairCode;
              if (code) {
                // Pair saving: apply the pouch code, keeping any codes already on the bag
                var cart = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
                var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
                if (!codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) codes.push(code);
                var u = await post(updateUrl(), { discount: codes.join(',') });
                render(u.cart, u.list);
              } else {
                render({ sections: r.cart.sections, item_count: 1 }, r.list);
              }
            } catch (err) {
              btn.disabled = false; self.classList.remove('is-busy');
              var m = self.querySelector('[data-addon-msg]'); if (m) m.textContent = (err.json && err.json.description) || 'Sorry, that could not be added.';
            }
          });
          // Shade chips change the photo
          this.querySelectorAll('[name="id"][data-img]').forEach(function (r) {
            r.addEventListener('change', function () { var im = self.querySelector('img'); if (im && r.dataset.img) { im.srcset = ''; im.src = r.dataset.img; } });
          });
          // Price (and any was-price) follow the chosen shade
          this.querySelectorAll('[name="id"][data-price]').forEach(function (r) {
            r.addEventListener('change', function () {
              var p = self.querySelector('[data-rca-price]'); if (p) p.textContent = r.dataset.price;
              var wrap = self.querySelector('.rca__price'), c = self.querySelector('[data-rca-compare]');
              if (r.dataset.compare) {
                if (!c && wrap) { c = document.createElement('s'); c.setAttribute('data-rca-compare', ''); wrap.prepend(c, ' '); }
                if (c) { c.textContent = r.dataset.compare; c.hidden = false; }
              } else if (c) { c.hidden = true; }
            });
          });
        }
      }
    );
  }

  // Theme quantity changes re-render the drawer and page too: keep dates filled in
  document.addEventListener('DOMContentLoaded', function () { dispatchDates(); shipRates(); });
  if (document.readyState !== 'loading') { dispatchDates(); shipRates(); }
  new MutationObserver(function () {
    if ([].some.call(document.querySelectorAll('[data-ship-rate]'), function (e) { return e.textContent === 'At checkout' && !e.dataset.asked; })) {
      document.querySelectorAll('[data-ship-rate]').forEach(function (e) { e.dataset.asked = '1'; });
      shipRates();
    }
    if (document.querySelector('[data-dispatch-by]:not(:empty)') && [].some.call(document.querySelectorAll('[data-dispatch-by]'), function (e) { return e.textContent.indexOf('within') === 0; })) dispatchDates();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
